/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/* prettier-ignore */


export const $ServiceNumberIndexRequest = {
    properties: {
        serviceNumber: {
            type: 'string',
        },
        subscriptionId: {
            type: 'number',
            isNullable: true,
        },
        scenarioId: {
            type: 'number',
            isNullable: true,
        },
        isActive: {
            type: 'number',
        },
        custOrderNumber: {
            type: 'string',
            isNullable: true,
        },
        custExtRef1: {
            type: 'string',
            isNullable: true,
        },
        custExtRef2: {
            type: 'string',
            isNullable: true,
        },
        custExtRef3: {
            type: 'string',
            isNullable: true,
        },
        filename: {
            type: 'string',
        },
        page: {
            type: 'number',
        },
        pageSize: {
            type: 'number',
        },
        accountId: {
            type: 'number',
        },
    },
};